import { render, staticRenderFns } from "./RenewButton.vue?vue&type=template&id=6ad6d0f7&"
import script from "./RenewButton.vue?vue&type=script&lang=ts&"
export * from "./RenewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports